import { ApiCore } from '@/services/api/utils/core.js'

const url = 'data-elements'
const plural = 'dataelements'
const single = 'dataelement'

const api = new ApiCore({
	index: true,
	findOne: false,
	findAll: true,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

export default api
